module.exports = __webpack_public_path__ + "media/assets_v3/images/payment-methods/epin-3b72d58f6c768d06f9e6f4079c62c445.png";